import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath.jsx";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
dayjs.extend(updateLocale);
dayjs.updateLocale("en", {
  weekStart: 1,
});
import enUS from "antd/es/calendar/locale/en_US";
import {
  ROLL_CALL_API_BASE_URL,
  ROLL_CALL_EMP_PROFILE,
} from "../RollCallConfig/RollCallConfig.js";
import { Spin, Tooltip, Input, Calendar, Select } from "antd";
import Swal from "sweetalert2";
import CommonFooter from "../../../../core/common/footer/commonFooter.jsx";
import badge from "../RollCallConfig/id-card-svgrepo-com.svg";
import designation from "../RollCallConfig/suitcase-portfolio-svgrepo-com.svg";
import email from "../RollCallConfig/mail-svgrepo-com.svg";
import { Table as AntTable } from "antd";
import DynamicKPIForm from "./DynamicKPIForm.jsx";
const { Option } = Select;

const KPiDashboard = () => {
  const today = new Date();
  const formattedDate = today.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [time, setTime] = useState("");
  const [loading, setloading] = useState(false);
  const [greeting, setGreeting] = useState("");
  const [profileData, setProfileData] = useState("");
  const [value, setValue] = useState(dayjs());
  const [kpiLoading, setKpiLoading] = useState(false);
  const [calendarData, setCalendarData] = useState({});
  const [KPICalenderLoading, setKPICalenderLoading] = useState(false);
  const [selectedCalendarDate, setSelectedCalendarDate] = useState(
    dayjs().format("YYYY-MM-DD"),
  );

  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [branchsLoading, setBranchesLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("daily");

  const startYear = 2026;
  const currentYearCalender = dayjs().year();
  const [dashboardCounts, setDashboardCounts] = useState(null);
  const [dashboardCountsLoading, setDashboardCountsLoading] = useState(false);
  const years = [];
  for (let i = startYear; i <= currentYearCalender; i++) {
    years.push(i);
  }

  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const regId = userData?.RegId;
  const [dailyData, setDailyData] = useState([]);
  const [weeklyData, setWeeklyData] = useState([]);
  const [monthlyData, setMonthlyData] = useState([]);

  const [originalDailyData, setOriginalDailyData] = useState([]);
  const [originalWeeklyData, setOriginalWeeklyData] = useState([]);
  const [originalMonthlyData, setOriginalMonthlyData] = useState([]);

  const [bulkEdit, setBulkEdit] = useState(false);
  const [kpiSubmitLoading, setKpiSubmitLoading] = useState(false);
  const [viewMode, setViewMode] = useState("table"); // "table" or "form"
  const [selectedKpiForForm, setSelectedKpiForForm] = useState(null);

  const navigate = useNavigate();
  console.log(dailyData, "dailyData data");
  const handleInputChange = (type, id, field, value) => {
    const updateData = (setter) => {
      setter((prev) =>
        prev.map((item) =>
          item.id === id
            ? {
                ...item,
                [field]: value,
              }
            : item,
        ),
      );
    };

    if (type === "daily") {
      updateData(setDailyData);
    }

    if (type === "weekly") {
      updateData(setWeeklyData);
    }

    if (type === "monthly") {
      updateData(setMonthlyData);
    }
  };

  const handleBulkEdit = () => {
    setOriginalDailyData(JSON.parse(JSON.stringify(dailyData)));
    setOriginalWeeklyData(JSON.parse(JSON.stringify(weeklyData)));
    setOriginalMonthlyData(JSON.parse(JSON.stringify(monthlyData)));

    setBulkEdit(true);
  };

  const handleCancelBulkEdit = () => {
    setDailyData(originalDailyData);
    setWeeklyData(originalWeeklyData);
    setMonthlyData(originalMonthlyData);

    setBulkEdit(false);
  };
  const handleBulkSave = async () => {
    try {
      setKpiSubmitLoading(true);

      let currentData = [];

      if (activeTab === "daily") {
        currentData = dailyData;
      }

      if (activeTab === "weekly") {
        currentData = weeklyData;
      }

      if (activeTab === "monthly") {
        currentData = monthlyData;
      }

      const payload = {
        Data: currentData.map((item) => ({
          Id: item.id,
          Achieved: Number(item.Achieved || 0),
          Notes: item.Notes || "",
          BranchId: item.BranchId,
          UserId: regId,
        })),
      };

      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}ess/kpi/UpdateKPIResponsesall`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (!response.ok || !data?.status) {
        throw new Error(data?.message || "Failed to update KPI");
      }

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "KPI updated successfully",
      });

      setBulkEdit(false);

      fetchKPI();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message,
      });
    } finally {
      setKpiSubmitLoading(false);
    }
  };

  const fetchKPIDates = async (dateValue, selectedBranch) => {
    console.log(selectedBranch, "selectedBranch");
    console.log(typeof selectedBranch);
    try {
      setKPICalenderLoading(true);
      const fromDate = dayjs(dateValue).startOf("month").format("YYYY-MM-DD");
      const toDate = dayjs(dateValue).endOf("month").format("YYYY-MM-DD");
      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}ess/kpi/getkpidates?Fromdate=${fromDate}&Todate=${toDate}&SuperId=${superIdData}&BranchId=${selectedBranch}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokenData}`,
          },
        },
      );

      const data = await response.json();

      if (!data?.status) return;

      const groupedDetails = {};
      const groupedBadges = {};

      data.ResultData.forEach((item) => {
        const dateKey = dayjs(item.DateOfTransaction).format("YYYY-MM-DD");

        // badge logic
        let color = "danger";
        if (item.IsProcessed) {
          color = "success";
        } else if (!item.IsProcessed && item.IsValid) {
          color = "warning";
        }

        const letter = item.GroupName?.charAt(0)?.toUpperCase();

        // badges
        if (!groupedBadges[dateKey]) {
          groupedBadges[dateKey] = {};
        }
        groupedBadges[dateKey][letter] = color;

        // full details
        if (!groupedDetails[dateKey]) {
          groupedDetails[dateKey] = [];
        }
        groupedDetails[dateKey].push(item);
      });

      setCalendarData(groupedBadges);
    } catch (err) {
      console.error("Error fetching KPI dates:", err);
    } finally {
      setKPICalenderLoading(false);
    }
  };

  const resetBulkEdit = () => {
    setBulkEdit(false);
  };

  useEffect(() => {
    if (tokenData && superIdData) {
      fetchKPIDates(value, selectedBranch);
    }
  }, [tokenData, selectedBranch]);

  const handleDateSelect = (value) => {
    let dateObj;

    if (typeof value === "string") {
      dateObj = dayjs(value);
    } else {
      dateObj = value;
    }

    const dateKey = dateObj.format("YYYY-MM-DD");

    setSelectedCalendarDate(dateKey);
  };

  //region greetings
  useEffect(() => {
    const updateTimeAndGreeting = () => {
      const now = new Date();
      const hours = now.getHours();
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");

      // Set time
      const formattedTime = `${String(hours).padStart(
        2,
        "0",
      )}:${minutes}:${seconds}`;
      setTime(formattedTime);

      // Set greeting
      if (hours >= 5 && hours < 12) {
        setGreeting("Good Morning");
      } else if (hours >= 12 && hours < 17) {
        setGreeting("Good Afternoon");
      } else {
        setGreeting("Good Evening");
      }
    };

    updateTimeAndGreeting();
    const intervalId = setInterval(updateTimeAndGreeting, 1000);

    return () => clearInterval(intervalId);
  }, []);

  //region session
  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  //region profile
  useEffect(() => {
    setloading(true);

    if (tokenData && superIdData) {
      fetch(
        `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_EMP_PROFILE}?regid=${regId}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        },
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data && data.status) {
            setProfileData(data.ResultData || []);
          } else {
            console.error("Invalid data format:", data);
            setProfileData([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setloading(false);
        });
    }
  }, [superIdData, tokenData]);

  const fetchKPI = () => {
    if (!selectedBranch) return;

    setKpiLoading(true);

    const superId = sessionStorage.getItem("superId");

    fetch(
      `${ROLL_CALL_API_BASE_URL}ess/kpi/getkpiresponse?KPIGroup=0&BranchId=${selectedBranch}&Fromdate=${selectedCalendarDate}&Todate=${selectedCalendarDate}&SuperId=${superId}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${tokenData}`,
        },
      },
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data, "FULL API");

        if (data.Status) {
          const result = data.ResultData || {};

          const formattedData = {
            daily: (result.Daily || []).map((item, index) => ({
              ...item,
              key: item.Id || index,
            })),

            weekly: (result.Weekly || []).map((item, index) => ({
              ...item,
              key: item.Id || index,
            })),

            monthly: (result.Monthly || []).map((item, index) => ({
              ...item,
              key: item.Id || index,
            })),
          };

          console.log(formattedData, "FORMATTED DATA");

          setDailyData(result.Daily || []);
          setWeeklyData(result.Weekly || []);
          setMonthlyData(result.Monthly || []);
          setBulkEdit(false);
        }
      })
      .catch((err) => {
        console.error("KPI API Error:", err);
      })
      .finally(() => setKpiLoading(false));
  };

  const fetchBranches = () => {
    setBranchesLoading(true);

    if (tokenData && superIdData) {
      fetch(
        `${ROLL_CALL_API_BASE_URL}portal/kpi/getKPIEmpBranch?RegId=${regId}`,
        {
          headers: { Authorization: `Bearer ${tokenData}` },
        },
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status && data.ResultData.length > 0) {
            setBranches(data.ResultData);

            const defaultBranch = data.ResultData.find(
              (item) => item.IsDefaultBranch === 1,
            );

            setSelectedBranch(
              defaultBranch
                ? defaultBranch.BranchId
                : data.ResultData[0].BranchId,
            );
          } else {
            console.error("Unexpected API response:", data);
          }
        })
        .catch((error) => {
          console.error("Error fetching branches", error);
        })
        .finally(() => setBranchesLoading(false));
    }
  };

  useEffect(() => {
    const fetchDashboardCounts = async () => {
      if (!superIdData) {
        return;
      }
      try {
        setDashboardCountsLoading(true);

        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/kpi/getKPIDashBoardCounts?SuperId=${superIdData}`,
          {
            headers: { Authorization: `Bearer ${tokenData}` },
          },
        );

        const data = await response.json();

        if (data?.status) {
          setDashboardCounts(data.ResultData[0]);
        } else {
          console.error("API returned false status");
        }
      } catch (error) {
        console.error("Error fetching dashboard counts:", error);
      } finally {
        setDashboardCountsLoading(false);
      }
    };

    fetchDashboardCounts();
  }, [superIdData]);

  useEffect(() => {
    fetchBranches();
  }, [regId, tokenData]);

  useEffect(() => {
    if (selectedCalendarDate) {
      handleDateSelect(selectedCalendarDate);
    }
    setActiveTab("daily");
    fetchKPI();
  }, [selectedCalendarDate, selectedBranch]);

  const handleDynamicSave = async (entries) => {
    if (!entries || entries.length === 0) return;

    const superId = sessionStorage.getItem("superId");
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    const createdBy = userData?.UserId || userData?.RegId;

    const payloadData = entries.map((entry) => ({
      Id: entry.id && entry.id < 1000000 ? entry.id : 0, // Real Id if exists, else 0
      SuperId: Number(superId),
      BranchId: selectedKpiForForm?.BranchId || selectedBranch,
      MetricId: selectedKpiForForm?.MetricsId || selectedKpiForForm?.MetricId,
      DateOfTransaction: selectedCalendarDate,
      Value: entry.HasValue ? Number(entry.Value) || 0 : null,
      Notes: entry.Notes || "",
      Flag: entry.HasFlag ? (entry.Value ? 1 : 0) : null,
      IsActive: true,
      CreatedBy: createdBy,
      DetailsId: entry.MetricDetailId,
    }));

    const payload = { Data: payloadData };

    try {
      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/kpi/upsertKpiResponseDetails`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
          body: JSON.stringify(payload),
        },
      );

      const result = await response.json();

      if (result.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Details saved successfully!",
        });

        setViewMode("table");
        fetchKPI(); // Refresh table
      } else {
        Swal.fire("Error", result.message || "Failed to save", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Something went wrong while saving", "error");
    }
  };
  const handleAddDetails = (record) => {
    setSelectedKpiForForm(record);
    setViewMode("form");
  };

  const kpiColumns = [
    {
      title: "Metric",
      dataIndex: "MetricName",
      render: (text) => {
        if (!text) return "-";
        return (
          <Tooltip title={text}>
            {text.length > 25 ? text.slice(0, 25) + "..." : text}
          </Tooltip>
        );
      },
    },

    {
      title: "Target",
      dataIndex: "Target",
      render: (val) => (
        <span>
          {val === 0 || val === null || val === undefined ? "-" : val}
        </span>
      ),
    },
    {
      title: "Achieved",
      dataIndex: "Achieved",
      render: (val, record) => {
        return bulkEdit ? (
          <Input
            type="number"
            min={0}
            value={record.Achieved ?? ""}
            onWheel={(e) => e.target.blur()}
            onChange={(e) =>
              handleInputChange(
                activeTab,
                record.id,
                "Achieved",
                e.target.value,
              )
            }
          />
        ) : (
          (val ?? "-")
        );
      },
    },
    {
      title: "Notes",
      dataIndex: "Notes",
      render: (text, record) => {
        return bulkEdit ? (
          <Input
            value={record.Notes ?? ""}
            onChange={(e) =>
              handleInputChange(activeTab, record.id, "Notes", e.target.value)
            }
          />
        ) : text ? (
          <Tooltip title={text}>
            <i
              className="fa-regular fa-note-sticky text-primary"
              style={{ cursor: "pointer", fontSize: "16px" }}
            />
          </Tooltip>
        ) : (
          "-"
        );
      },
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => {
        const showPlusButton = record.HasDetails === true;

        return (
          <div className="d-flex justify-content-center gap-2">
            {/* + Button - New */}
            {showPlusButton && (
              <Tooltip title="Add / Update Details">
                <button
                  className="btn btn-sm btn-light border-0"
                  onClick={() => {
                    handleAddDetails(record);
                  }}
                >
                  <i className="fa-solid fa-plus-circle  text-success" />
                </button>
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];

  const headerRender = ({ value, onChange }) => {
    const year = value.year();
    const month = value.month();

    return (
      <div className="d-flex justify-content-between align-items-center p-2">
        <div>
          <Select
            className="me-1"
            value={year}
            onChange={(newYear) => {
              const newValue = value.clone().year(newYear);
              onChange(newValue);
              setValue(newValue);
              fetchKPIDates(newValue, selectedBranch);
            }}
          >
            {years.map((y) => (
              <Select.Option key={y} value={y}>
                {y}
              </Select.Option>
            ))}
          </Select>

          <Select
            value={month}
            style={{ width: 105 }}
            onChange={(newMonth) => {
              const newValue = value.clone().month(newMonth);
              onChange(newValue);
              setValue(newValue);
              fetchKPIDates(newValue, selectedBranch);
            }}
          >
            {Array.from({ length: 12 }, (_, i) => (
              <Select.Option key={i} value={i}>
                {dayjs().month(i).format("MMMM")}
              </Select.Option>
            ))}
          </Select>
        </div>

        <div>
          <div className="d-flex">
            <div className="d-flex  align-items-center">
              <span
                className={`badge rounded-pill text-white badge-sm bg-success me-1`}
                style={{
                  width: "15px",
                  height: "15px",
                  display: "inline-flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "0.55rem",
                }}
              ></span>
              Done
              <span
                className={`badge rounded-pill text-white badge-sm bg-warning mx-1`}
                style={{
                  width: "15px",
                  height: "15px",
                  display: "inline-flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "0.55rem",
                }}
              ></span>
              Pending
              <span
                className={`badge rounded-pill text-white badge-sm bg-danger mx-1`}
                style={{
                  width: "15px",
                  height: "15px",
                  display: "inline-flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "0.55rem",
                }}
              ></span>
              Due
            </div>
          </div>
          {/* <div className="d-flex">D-Daily, W-Weekly, M-Monthly</div> */}
        </div>
      </div>
    );
  };

  const dateCellRender = (value) => {
    const dateKey = value.format("YYYY-MM-DD");
    const badges = calendarData[dateKey];

    if (!badges) return null;

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          marginTop: 2,
        }}
      >
        {Object.keys(badges).map((letter) => (
          <span
            key={letter}
            className={`badge rounded-pill text-white bg-${badges[letter]}`}
            style={{
              width: "15px",
              height: "15px",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "0.55rem",
            }}
          >
            {letter}
          </span>
        ))}
      </div>
    );
  };

  const formatAmount = (value) => {
    if (!value) return "0";

    const num = Number(value.toString().replace(/,/g, ""));

    if (num >= 10000000) {
      return (num / 10000000).toFixed(1).replace(/\.0$/, "") + "Cr";
    } else if (num >= 100000) {
      return (num / 100000).toFixed(1).replace(/\.0$/, "") + "L";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
    } else {
      return num.toString();
    }
  };

  return (
    <div>
      {(kpiSubmitLoading || loading) && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="page-wrapper pt-5">
        <div className="content">
          <div className="attendance-header">
            <div className="attendance-content">
              <ImageWithBasePath
                src="./assets/img/icons/hand01.svg"
                className="hand-img"
                alt="img"
              />
              <h3>
                {greeting}, <span>{userData?.UserName}</span>
              </h3>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-3 col-lg-12 d-flex">
              <div className="card w-100 border-0">
                <div className="card-body">
                  <h5 className="mb-3 pb-3 border-bottom d-flex justify-content-between align-items-center fs-18">
                    <i className="fa-solid fa-user-clock"></i>Attendance
                    <span className="text-purple fs-14">{formattedDate}</span>
                  </h5>
                  <div className="d-flex align-items-center mb-3">
                    <div className="me-2">
                      <ImageWithBasePath
                        src="./assets/img/icons/time-big.svg"
                        alt="time-img"
                      />
                    </div>
                    <div>
                      <h2>{time}</h2>
                      <p>Current Time</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <button className="w-100 me-2 btn btn-primary" disabled>
                      Clock In
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-9 col-lg-12 d-flex">
              <div className="card w-100 border-0">
                <div className="card-header px-1 d-none d-lg-block">
                  <div className="row my-1">
                    <div className="col-3 border-end">
                      <h5 className="ms-2">
                        <i className="fa-solid fa-circle-info me-2"></i>Details
                      </h5>
                    </div>
                    <div className="col-9 ">
                      <h5>
                        <i className="fa-solid fa-chart-column me-2"></i>
                        Monthly KPI Overview
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="card-body p-2">
                  <div className="row">
                    <div className="col-12 col-lg-3 border-end rounded ">
                      <div className="p-2 ">
                        <h5 className="ms-2 p-2 mb-2 d-block d-lg-none">
                          <i className="fa-solid fa-circle-info me-2"></i>
                          Details
                        </h5>
                        <div className="mb-2 d-flex align-items-center">
                          <img
                            src={designation}
                            style={{ width: "20px" }}
                            className="me-2"
                          />
                          <h6 className="text-gray">
                            {profileData[0]?.Designation || "N/A"}
                          </h6>
                        </div>
                        <div className="mb-2 d-flex align-items-center">
                          <img
                            src={badge}
                            style={{ width: "20px" }}
                            className="me-2"
                          />
                          <h6 className="text-gray">
                            {profileData[0]?.Badge || "N/A"}
                          </h6>
                        </div>
                        <div className="mb-2 d-flex align-items-center">
                          <img
                            src={email}
                            style={{ width: "20px" }}
                            className="me-2"
                          />
                          <Tooltip title={profileData[0]?.EmailId || "N/A"}>
                            <h6 className="text-gray">
                              {profileData[0]?.EmailId
                                ? profileData[0].EmailId.length > 18
                                  ? `${profileData[0].EmailId.slice(0, 15)}...`
                                  : profileData[0].EmailId
                                : "N/A"}
                            </h6>
                          </Tooltip>
                        </div>
                        <div className="mb-2 d-flex align-items-center">
                          <i className="fa-solid fa-phone me-2 fa-lg text-info"></i>
                          <h6 className="text-gray">
                            {profileData[0]?.Mobile || "N/A"}
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-lg-9">
                      <h5 className="ms-2 p-2 mb-2 d-block d-lg-none">
                        <i className="fa-solid fa-chart-column me-2"></i>
                        Monthly KPI Overview
                      </h5>
                      {dashboardCountsLoading ? (
                        <div className="row gy-3 d-flex justify-content-between">
                          <p>Loading...</p>
                        </div>
                      ) : (
                        <div className="row gy-3 d-flex justify-content-between">
                          <div className="col text-center">
                            <div>
                              <span
                                className="d-flex align-items-center justify-content-center avatar avatar-xl bg-primary-transparent fw-bold  mb-2 mx-auto"
                                title={dashboardCounts?.YearCollection}
                              >
                                <h5 className="text-primary">
                                  {formatAmount(
                                    dashboardCounts?.YearCollection,
                                  )}
                                </h5>
                              </span>
                              <p className="fs-14">
                                Collections <br />
                                YTD
                              </p>
                            </div>
                          </div>
                          <div className="col text-center">
                            <div>
                              <span
                                className="d-flex align-items-center justify-content-center avatar avatar-xl bg-danger-transparent fw-bold  mb-2 mx-auto"
                                title={dashboardCounts?.YearExpenses}
                              >
                                <h5 className="text-danger">
                                  {formatAmount(dashboardCounts?.YearExpenses)}
                                </h5>
                              </span>
                              <p className="fs-14">
                                Expenses
                                <br />
                                YTD
                              </p>
                            </div>
                          </div>
                          <div className="col text-center">
                            <div>
                              <span
                                className="d-flex align-items-center justify-content-center avatar avatar-xl bg-purple-transparent text-purple fw-bold  mb-2 mx-auto"
                                title={dashboardCounts?.CurrentMonthExpenses}
                              >
                                <h5 className="text-purple">
                                  {formatAmount(
                                    dashboardCounts?.CurrentMonthExpenses,
                                  )}
                                </h5>
                              </span>
                              <p className="fs-14">
                                This Month <br />
                                Expenses
                              </p>
                            </div>
                          </div>

                          <div className="col text-center">
                            <div>
                              <span
                                className="d-flex align-items-center justify-content-center avatar avatar-xl bg-cyan-transparent text-cyan fw-bold  mb-2 mx-auto"
                                title={dashboardCounts?.CurrentMonthCollection}
                              >
                                <h5 className="text-cyan">
                                  {formatAmount(
                                    dashboardCounts?.CurrentMonthCollection,
                                  )}{" "}
                                </h5>
                              </span>
                              <p className="fs-14">
                                This Month
                                <br />
                                Collection
                              </p>
                            </div>
                          </div>
                          <div className="col text-center">
                            <div>
                              <span
                                className="d-flex align-items-center justify-content-center avatar avatar-xl bg-success-transparent text-success fw-bold mb-2 mx-auto"
                                title={dashboardCounts?.Last_MonthKPI_Rating}
                              >
                                <h5 className="text-success">
                                  {formatAmount(
                                    dashboardCounts?.Last_MonthKPI_Rating,
                                  )}
                                </h5>
                              </span>
                              <p className="fs-14">
                                Last Month
                                <br /> KPI Rating
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <style>
              {`
                .custom-calendar .ant-picker-calendar-date-content {
                  height: 25px !important;
                  overflow-y: hidden !important;
                }

                .custom-calendar .ant-picker-cell-inner {
                  min-height: 25px !important;
                  padding: 4px !important;
                }
              `}
            </style>
            <div className="col-5 custom-calendar">
              <Calendar
                locale={enUS}
                loading={KPICalenderLoading}
                disabledDate={(current) =>
                  current && current > dayjs().endOf("day")
                }
                onSelect={(value) => {
                  resetBulkEdit();
                  handleDateSelect(value);
                }}
                value={value}
                onChange={(newValue) => {
                  resetBulkEdit();
                  setValue(newValue);
                  fetchKPIDates(newValue, selectedBranch);
                }}
                headerRender={headerRender}
                dateCellRender={dateCellRender}
              />
            </div>
            <div className="col-7 d-flex">
              <div className="flex-fill">
                {viewMode !== "form" && (
                  <div className="d-flex justify-content-end gap-2 mb-3">
                    {!bulkEdit ? (
                      <button
                        className="btn btn-primary"
                        onClick={handleBulkEdit}
                      >
                        Bulk Edit
                      </button>
                    ) : (
                      <>
                        <button
                          className="btn btn-success"
                          onClick={handleBulkSave}
                          disabled={kpiSubmitLoading}
                        >
                          {kpiSubmitLoading ? "Saving..." : "Save"}
                        </button>

                        <button
                          className="btn btn-secondary"
                          onClick={handleCancelBulkEdit}
                        >
                          Cancel
                        </button>
                      </>
                    )}
                  </div>
                )}
                <div className="card table-list-card no-search flex-fill">
                  {/* 🔹 Header with Tabs */}{" "}
                  {viewMode === "form" ? (
                    <DynamicKPIForm
                      record={selectedKpiForForm}
                      selectedDate={selectedCalendarDate} // Important for filtering
                      onCancel={() => setViewMode("table")}
                      onSave={handleDynamicSave}
                    />
                  ) : (
                    <>
                      <div className="card-header d-flex justify-content-between align-items-center flex-wrap pb-0 pt-2">
                        {/* Tabs */}
                        <ul className="nav nav-tabs nav-tabs-bottom mb-3">
                          {dailyData?.length > 0 && (
                            <li className="nav-item">
                              <Link
                                className={`nav-link ${activeTab === "daily" ? "active" : ""}`}
                                to="#daily"
                                data-bs-toggle="tab"
                                onClick={() => {
                                  resetBulkEdit();
                                  setActiveTab("daily");
                                }}
                              >
                                <i className="fa-solid fa-chart-line me-2"></i>
                                Daily KPI
                              </Link>
                            </li>
                          )}

                          {weeklyData?.length > 0 && (
                            <li className="nav-item">
                              <Link
                                className={`nav-link ${activeTab === "weekly" ? "active" : ""}`}
                                to="#weekly"
                                data-bs-toggle="tab"
                                onClick={() => {
                                  resetBulkEdit();
                                  setActiveTab("weekly");
                                }}
                              >
                                <i className="fa-solid fa-calendar-week me-2"></i>
                                Weekly
                              </Link>
                            </li>
                          )}

                          {monthlyData?.length > 0 && (
                            <li className="nav-item">
                              <Link
                                className={`nav-link ${activeTab === "monthly" ? "active" : ""}`}
                                to="#monthly"
                                data-bs-toggle="tab"
                                onClick={() => {
                                  resetBulkEdit();
                                  setActiveTab("monthly");
                                }}
                              >
                                <i className="fa-solid fa-calendar-alt me-2"></i>
                                Monthly
                              </Link>
                            </li>
                          )}
                        </ul>

                        <Select
                          value={selectedBranch}
                          loading={branchsLoading}
                          onChange={(value) => {
                            resetBulkEdit();
                            setSelectedBranch(value);
                          }}
                          style={{ width: 150 }}
                        >
                          {branches.map((branch) => (
                            <Option
                              key={branch.BranchId}
                              value={branch.BranchId}
                            >
                              {branch.BranchName}
                            </Option>
                          ))}
                        </Select>
                      </div>
                      <div className="card-body pb-0">
                        <div className="tab-content">
                          {/* Daily */}
                          <div
                            className={`tab-pane fade ${activeTab === "daily" ? "show active" : ""}`}
                            id="daily"
                          >
                            {kpiLoading ? (
                              <div className="text-center my-4">
                                <Spin size="large" />
                              </div>
                            ) : dailyData?.length > 0 ? (
                              <AntTable
                                columns={kpiColumns}
                                dataSource={dailyData}
                                rowKey="id"
                                showSizeChangerProp={false}
                                pagination={{
                                  pageSize: 31,
                                  showSizeChanger: false,
                                }}
                              />
                            ) : (
                              <p className="text-center my-4">
                                No Daily KPI data
                              </p>
                            )}
                          </div>

                          {/* Weekly */}
                          <div
                            className={`tab-pane fade ${activeTab === "weekly" ? "show active" : ""}`}
                            id="weekly"
                          >
                            {kpiLoading ? (
                              <div className="text-center my-4">
                                <Spin size="large" />
                              </div>
                            ) : weeklyData.length > 0 ? (
                              <AntTable
                                columns={kpiColumns}
                                dataSource={weeklyData}
                                rowKey="id"
                                showSizeChangerProp={false}
                                pagination={{
                                  pageSize: 31,
                                  showSizeChanger: false,
                                }}
                              />
                            ) : (
                              <p className="text-center my-4">
                                No Weekly KPI data
                              </p>
                            )}
                          </div>

                          {/* Monthly */}
                          <div
                            className={`tab-pane fade ${activeTab === "monthly" ? "show active" : ""}`}
                            id="monthly"
                          >
                            {kpiLoading ? (
                              <div className="text-center my-4">
                                <Spin size="large" />
                              </div>
                            ) : monthlyData?.length > 0 ? (
                              <AntTable
                                columns={kpiColumns}
                                dataSource={monthlyData}
                                rowKey="id"
                                showSizeChangerProp={false}
                                pagination={{
                                  pageSize: 31,
                                  showSizeChanger: false,
                                }}
                              />
                            ) : (
                              <p className="text-center my-4">
                                No Monthly KPI data
                              </p>
                            )}
                          </div>
                        </div>
                      </div>{" "}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
    </div>
  );
};

export default KPiDashboard;
